import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { contractingKeys } from "@/lib/query-keys";
import type { MyCompanyDocumentsState } from "@/types/domain";

/**
 * Los documentos de la propia empresa, agrupados por casilla. Alimenta la
 * cabecera de la pestaña de requisitos y Configuración → Documentos.
 *
 * No confundir con `useCompanyDocuments`, que es la vista de admin sobre los
 * documentos de OTRA organización y devuelve la lista completa.
 */
export function useMyCompanyDocuments(enabled = true) {
  return useQuery<MyCompanyDocumentsState>({
    queryKey: contractingKeys.companyDocuments(),
    queryFn: () => fetchToBackend("/organization/documents"),
    // Se recargan al subir o quitar uno, que es lo que invalida esta clave.
    staleTime: 5 * 60 * 1000,
    // Mientras la IA lee alguno se pregunta seguido: tarda de 30 s a un minuto
    // y el usuario está mirando la pantalla esperando que termine.
    refetchInterval: (query) =>
      query.state.data?.unreadDocuments.some((doc) => doc.state === "PROCESSING")
        ? 5000
        : false,
    enabled,
  });
}
